import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { VisualSection } from '../components/sales/VisualSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { OnePartSection } from '../components/sales/OnePartSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-213" data-mp="3vp4k854585go">
      <header className="border-b border-brand-charcoal/10 bg-brand-charcoal" data-id="element-214" data-mp="35t02xb90jwaj">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-215" data-mp="35qx4q3xpiwuq">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-216" data-mp="30ru8n8zpg0yw">
            Barber Instructor Ready™
          </p>
        </div>
      </header>

      <main data-id="element-217" data-mp="3ti2lclbh1t63">
        <HeroSection data-id="element-218" data-mp="3tghylhvefeis" />
        <InsideSection data-id="element-219" data-mp="3ojhrd3mtc5q3" />
        <PainSection data-id="element-220" data-mp="3oj80ldty1ujc" />
        <SolutionSection data-id="element-221" data-mp="3oksvj4k67fhq" />
        <VolumesSection data-id="element-222" data-mp="3oherzszrt08p" />
        <VisualSection data-id="element-223" data-mp="3jk4udq289i9s" />
        <BonusesSection data-id="element-224" data-mp="3jjmzawraxa3g" />
        <BeforeAfterSection data-id="element-225" data-mp="3jitsxww98mlu" />
        <AudienceSection data-id="element-226" data-mp="3jm99z59ho5pw" />
        <OfferSection data-id="element-227" data-mp="3fjcmp1907lfm" />
        <OnePartSection data-id="element-228" data-mp="3fhrtpg2c8ajv" />
        <FaqSection data-id="element-229" data-mp="3fijpaqvxq8a5" />
        <FinalSection data-id="element-230" data-mp="3fl5wgpewylru" />
      </main>

      <SiteFooter data-id="element-231" data-mp="285hu60fcqu6j" />
    </div>;
}